import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { SegmentButton, SegmentButtonGroup } from '../../../../components/common/buttons/SegmentButton';
import { SurveyForm } from '../../../../components/common/survey/form/SurveyForm';
import { SurveyInputHeader } from '../../../../components/common/survey/inputs/SurveyInputHeader';
import { sellTractorSurveySteps } from '../../../../constants/survey/sellTractorSurvey';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store/useStore';
import { userSellTractorSurveySlice } from '../../../../store/userSellTractorSurveySlice';
import { SellTractorSurveyPageWrapper } from '../SellTractorSurveyPageWrapper';
import { sellTractorPageInfo } from '../../../../constants/pageInfo/pageInfo.constant';

export const SellTractorSurveyTractorExtraInfo2Page = () => {
  const navigate = useNavigate();

  const [directImportYn, setDirectImportYn] = useState<boolean>();
  const [priceNegotiationYn, setPriceNegotiationYn] = useState<boolean>();
  const [informationText, setInformationText] = useState<string>('');

  const dispatch = useAppDispatch();
  const userSellTractorSurveyActions = userSellTractorSurveySlice.actions;
  const userSellTractorSurveySelector = useAppSelector((state) => state.userSellTractorSurvey);

  const currentStep = sellTractorSurveySteps.STEP6;
  const steps = Object.keys(sellTractorSurveySteps);

  useEffect(() => {
    const { directImportYn, priceNegotiationYn, information } = userSellTractorSurveySelector;
    setDirectImportYn(directImportYn);
    setPriceNegotiationYn(priceNegotiationYn);
    setInformationText(information || '');
  }, [
    userSellTractorSurveySelector.directImportYn,
    userSellTractorSurveySelector.priceNegotiationYn,
    userSellTractorSurveySelector.information,
  ]);

  const dispatchSellTractorInputValuesToStore = () => {
    if (directImportYn !== undefined) {
      dispatch(userSellTractorSurveyActions.changeDirectImportYn(directImportYn));
    }

    if (priceNegotiationYn !== undefined) {
      dispatch(userSellTractorSurveyActions.changePriceNegotiationYn(priceNegotiationYn));
    }

    if (informationText) {
      dispatch(userSellTractorSurveyActions.changeInformation(informationText));
    }
  };

  return (
    <SellTractorSurveyPageWrapper
      headerTitle={'매물에 대해 설명해주세요'}
      canConfirm
      confirmHandler={() => {
        dispatchSellTractorInputValuesToStore();
        navigate(sellTractorPageInfo.pricePage.path, { replace: true });
      }}
      closeHandler={dispatchSellTractorInputValuesToStore}
      prevButtonHandler={() => navigate('/survey/progress/sell-tractor/tire-condition', { replace: true })}
      steps={steps}
      currentStep={currentStep}
    >
      <SurveyForm>
        <SurveyInputSection>
          <SurveyInputHeader inputTitle={'추가 정보'} isOptional />

          <SegmentButtonGroup>
            <SegmentButton isSelected={!!priceNegotiationYn} onClick={() => setPriceNegotiationYn(!priceNegotiationYn)}>
              {'가격 협상 가능 💸'}
            </SegmentButton>
            <SegmentButton isSelected={!!directImportYn} onClick={() => setDirectImportYn(!directImportYn)}>
              {'직수입 매물이예요 🌟'}
            </SegmentButton>
          </SegmentButtonGroup>
        </SurveyInputSection>

        <SurveyInputSection>
          <SurveyInputHeader inputTitle={'매물에 대해서 설명을 해주세요'} isOptional />

          <DescriptionTextarea
            value={informationText}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setInformationText(e.target.value)}
            placeholder={
              userSellTractorSurveySelector.machineType === 'combine'
                ? '예) 실사용 시간이 적고, 유압 실린더 교체를 얼마전에 완료했어요. 오래오래 아껴 사용한 콤바인입니다.'
                : '예) 실사용 시간이 적고, 타이어 교체를 얼마전에 완료했어요. 오래오래 아껴 사용한 트랙터입니다.'
            }
          />
        </SurveyInputSection>
      </SurveyForm>
    </SellTractorSurveyPageWrapper>
  );
};

const SurveyInputSection = styled.div`
  display: flex;
  padding: 0px var(--radius-large, 16px) 24px var(--radius-large, 16px);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--radius-large, 16px);
  align-self: stretch;
`;

const DescriptionTextarea = styled.textarea`
  display: flex;
  min-height: 40px;
  padding: 10px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  border-radius: var(--radius-medium, 8px);
  border: 1px solid var(--Light-Scheme-Monochrome-grey20, #e4e4ed);
  background: var(--Light-Scheme-Monochrome-white, #fff);

  ::placeholder {
    color: var(--Light-Scheme-Monochrome-grey70, #a7a9b6);

    /* Body/Medium/m-regular */
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */
  }
`;
